import { IcInfor, Tabs } from '@fozito/common-ui';
import React from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import IcSupplier from './components/IcSupplier';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  flex: 1;
`;

const SettingLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const shopId = storage.shop_id.get();
  const token = storage.token.get();
  if (!token) return <Navigate to={'/login'} replace />;
  const tabs = [
    // {
    //   key: 'staff',
    //   label: 'STAFF',
    //   activeIcon: <IcMenuStaff fill='white' />,
    //   inactiveIcon: <IcMenuStaff />,
    // },
    // {
    //   key: 'gift-card',
    //   label: 'GIFT CARD',
    //   activeIcon: <IcPaymentTypeGiftCard fill='white' />,
    //   inactiveIcon: <IcPaymentTypeGiftCard />,
    // },
    {
      key: 'general_configuration',
      label: 'GENERAL CONFIGURATIONㅤ',
      activeIcon: (
        <>
          ㅤ<IcInfor fill='white' />
        </>
      ),
      inactiveIcon: (
        <>
          ㅤ<IcInfor />
        </>
      ),
    },
    {
      key: 'supplier',
      label: 'SUPPLIER',
      activeIcon: (
        <>
          ㅤ<IcSupplier />
        </>
      ),
      inactiveIcon: (
        <>
          ㅤ<IcSupplier fill='black' />
        </>
      ),
    },
  ];

  const pathToKey: Record<string, string> = {
    [`/store/${shopId}/setting/staff/`]: 'staff',
    [`/store/${shopId}/setting/gift-card/`]: 'gift-card',
    [`/store/${shopId}/setting/general_configuration`]: 'general_configuration',
    [`/store/${shopId}/setting/general_configuration/cash_discount`]: 'general_configuration',
    [`/store/${shopId}/setting/general_configuration/fee_credit_cash`]: 'general_configuration',
    [`/store/${shopId}/setting/general_configuration/loyalty`]: 'general_configuration',
    [`/store/${shopId}/setting/general_configuration/promotions`]: 'general_configuration',
    [`/store/${shopId}/setting/supplier`]: 'supplier',
  };

  const keyToPath: Record<string, string> = Object.entries(pathToKey).reduce(
    (acc, [path, key]) => ({
      ...acc,
      [key]: path,
    }),
    {}
  );

  const activeKey = pathToKey[location.pathname];

  const handleTabChange = (key: string) => {
    if (key === 'general_configuration') {
      navigate(`/store/${shopId}/setting/general_configuration`);
    } else {
      navigate(keyToPath[key]);
    }
  };

  return (
    <Container>
      {activeKey && (
        <Tabs
          items={tabs}
          activeKey={activeKey}
          onChange={handleTabChange}
          height={50}
          minWidth={250}
        />
      )}
      <Content>
        <Outlet />
      </Content>
    </Container>
  );
};

export default SettingLayout;
